import { env } from '@/shared/lib/env';

export const ENDPOINT_STORAGE_KEY = 'els.graphql.endpoint';

export const isGraphqlEndpointUrl = (value: string): boolean => {
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};

const getDefaultGraphqlEndpoint = (): string => {
  if (isGraphqlEndpointUrl(env.VITE_GRAPHQL_URL)) {
    return env.VITE_GRAPHQL_URL;
  }

  return `${window.location.origin}/graphql`;
};

export const getGraphqlEndpoint = (): string => {
  if (typeof window === 'undefined') {
    return env.VITE_GRAPHQL_URL;
  }

  const savedEndpoint = window.localStorage.getItem(ENDPOINT_STORAGE_KEY);

  return savedEndpoint && isGraphqlEndpointUrl(savedEndpoint) ? savedEndpoint : getDefaultGraphqlEndpoint();
};

export const setGraphqlEndpoint = (url: string): void => {
  if (!isGraphqlEndpointUrl(url)) {
    throw new Error('GraphQL endpoint must be a valid HTTP or HTTPS URL.');
  }

  window.localStorage.setItem(ENDPOINT_STORAGE_KEY, url);
};

export const getSubscriptionsEndpoint = (): string | undefined => {
  const value = env.VITE_GRAPHQL_SUBSCRIPTIONS_URL;
  if (!value) {
    return undefined;
  }
  return `${window.location.origin}${value}`;
};